import type { Locale } from 'date-fns';
import * as DateFns from 'date-fns';
import { enUS } from 'date-fns/locale';

export class TimeOnly {
  private date: Date;

  constructor(hours: number = 0, minutes: number = 0, seconds: number = 0) {
    this.date = new Date();
    this.date.setHours(hours, minutes, seconds, 0);
  }

  getHours(): number {
    return this.date.getHours();
  }

  getMinutes(): number {
    return this.date.getMinutes();
  }

  getSeconds(): number {
    return this.date.getSeconds();
  }

  setHours(hours: number): void {
    this.date.setHours(hours);
  }

  setMinutes(minutes: number): void {
    this.date.setMinutes(minutes);
  }

  setSeconds(seconds: number): void {
    this.date.setSeconds(seconds);
  }

  addHours(hours: number): void {
    this.date.setHours(this.date.getHours() + hours);
  }

  addMinutes(minutes: number): void {
    this.date.setMinutes(this.date.getMinutes() + minutes);
  }

  addSeconds(seconds: number): void {
    this.date.setSeconds(this.date.getSeconds() + seconds);
  }

  toString(format: string = 'p', local: Locale = enUS): string {
    return DateFns.format(this.date, format, { locale: local });
  }
}
